import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { api, errMsg, fmtDate } from "@/lib/api";

function ProposalActions({ p, onDone }) {
  const [mode, setMode] = useState(null);
  const [f, setF] = useState({ titolo: p.titolo, spiegazione: p.spiegazione, condizione_verifica: "", nota: "", theory_id: "" });
  const [theories, setTheories] = useState([]);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const openMerge = async () => {
    setMode("merge");
    const r = await api.get(`/admin/dossiers/${p.dossier_id}`);
    setTheories(r.data.teorie.filter((t) => ["bozza", "pubblicata"].includes(t.stato)));
  };
  const run = async (action, body) => {
    try {
      await api.post(`/admin/proposals/${p.id}/${action}`, body);
      toast.success("Fatto");
      onDone();
    } catch (e) { toast.error(errMsg(e)); }
  };
  if (!mode)
    return (
      <div className="flex flex-wrap gap-2">
        <Button size="sm" className="rounded-full" onClick={() => setMode("approve")} data-testid={`approve-proposal-button-${p.id}`}>Approva…</Button>
        <Button size="sm" variant="outline" className="rounded-full" onClick={openMerge} data-testid={`merge-proposal-button-${p.id}`}>Unisci a esito…</Button>
        <Button size="sm" variant="ghost" className="rounded-full text-destructive" onClick={() => setMode("reject")} data-testid={`reject-proposal-button-${p.id}`}>Rifiuta…</Button>
      </div>
    );
  return (
    <div className="space-y-2 rounded-xl border border-border p-3">
      {mode === "approve" && (<>
        <Input value={f.titolo} onChange={set("titolo")} data-testid="approve-title-input" />
        <Textarea value={f.spiegazione} onChange={set("spiegazione")} rows={3} data-testid="approve-explanation-input" />
        <Input value={f.condizione_verifica} onChange={set("condizione_verifica")} placeholder="Condizione di verifica dell'esito" data-testid="approve-condition-input" />
        <p className="text-xs text-muted-foreground">Crea un esito con attribuzione community, pubblico e votabile subito (in bozza se i pronostici sono chiusi).</p>
      </>)}
      {mode === "merge" && (
        <select className="luma-select" value={f.theory_id} onChange={set("theory_id")} data-testid="merge-theory-select">
          <option value="">Scegli l'esito equivalente…</option>
          {theories.map((t) => <option key={t.id} value={t.id}>{t.titolo} ({t.stato})</option>)}
        </select>
      )}
      <Input value={f.nota} onChange={set("nota")} placeholder="Nota di revisione (facoltativa)" data-testid="review-note-input" />
      <div className="flex gap-2">
        <Button size="sm" className="rounded-full" data-testid="confirm-review-button"
          onClick={() => run(mode, mode === "approve" ? f : mode === "merge" ? { theory_id: f.theory_id, nota: f.nota } : { nota: f.nota })}>Conferma</Button>
        <Button size="sm" variant="ghost" onClick={() => setMode(null)}>Annulla</Button>
      </div>
    </div>
  );
}

export function ProposalsTab({ onChange }) {
  const [stato, setStato] = useState("in_attesa");
  const [list, setList] = useState([]);
  const load = useCallback(() => api.get("/admin/proposals", { params: { stato } }).then((r) => setList(r.data)), [stato]);
  useEffect(() => { load(); }, [load]);
  const done = () => { load(); onChange(); };
  return (
    <div className="space-y-4">
      <select className="luma-select max-w-xs" value={stato} onChange={(e) => setStato(e.target.value)} data-testid="proposals-filter-select">
        <option value="in_attesa">In attesa</option><option value="approvata">Approvate</option>
        <option value="unita">Unite</option><option value="rifiutata">Rifiutate</option><option value="">Tutte</option>
      </select>
      {!list.length && <p className="text-muted-foreground">Nessuna proposta.</p>}
      {list.map((p) => (
        <div key={p.id} className="luma-card space-y-2 text-sm" data-testid={`proposal-${p.id}`}>
          <p className="text-xs text-muted-foreground">{fmtDate(p.created_at)} · {p.autore_nome} · <Link className="text-primary" to={`/admin/dossier/${p.dossier_id}`}>{p.dossier_titolo}</Link></p>
          <h4 className="font-semibold">{p.titolo}</h4>
          <p className="whitespace-pre-line">{p.spiegazione}</p>
          {p.indizi && <p className="text-muted-foreground">Indizi: {p.indizi}</p>}
          {p.fonte_url && <p className="break-all text-xs text-amber-300">Fonte indicata (NON verificata): {p.fonte_url}</p>}
          {p.stato === "in_attesa" ? <ProposalActions p={p} onDone={done} /> : <p className="text-xs text-muted-foreground">Esito revisione: {p.stato} {p.revisione?.nota}</p>}
        </div>
      ))}
    </div>
  );
}
